import LabServiceModel from "@/models/LabServiceModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";

export default class AnalyteModel extends LabServiceModel {

  modelName() {
    return 'analyte';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.fetch = process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/{id}';
    return routes;
  }

  defaults() {
    return {
      id: null,
      sample_type_id: null,
      sample_type: null,
      name: null,
      abbrev: null,
      modus_name: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      sample_type: Object,
      name: (val) => (this.nullStringMutator(val)),
      abbrev: (val) => (this.nullStringMutator(val)),
      modus_name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }

}
